import { Condition as ModelCondition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type TotalSpentGreaterThanState = string;

export const TOTAL_SPENT_GREATER_THAN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<TotalSpentGreaterThanState>
  >,
): ConditionType<
  TotalSpentGreaterThanState,
  ModelCondition.TotalSpentGreaterThan
> => ({
  name: "Total spent greater than",
  description(state) {
    return `More than $${+state} spent`;
  },
  Details(props: ConditionTypeDetailsProps<TotalSpentGreaterThanState>) {
    return React.createElement(Details, props);
  },
  empty: String(0),
  fromModel(model) {
    return model.totalSpent;
  },
  toModel(state) {
    return { type: ModelCondition.TOTAL_SPENT_GREATER_THAN, totalSpent: state };
  },
  valid(state) {
    return state !== undefined;
  },
});
